import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCreateLiveStreamRequestBody,
  IApiCreateLiveStreamResponseBody,
} from '../LiveStreamsApi.types';
import { useApi } from '~/lib/api/useApi';
import { liveStreamQueryKeyFactory } from './useLiveStreamQuery';
import { liveStreamsQueryKeyFactory } from './useLiveStreamsQuery';

export type IUseCreateLiveStreamMutationValues = {
  appId: string;
  body: IApiCreateLiveStreamRequestBody;
};

export const useCreateLiveStreamMutation = (): UseMutationResult<
  IApiCreateLiveStreamResponseBody,
  unknown,
  IUseCreateLiveStreamMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCreateLiveStreamMutationValues) =>
      api.liveStreams.create(values.appId, values.body),
    onSuccess: async (createdLiveStream, values) => {
      queryClient.setQueryData(
        liveStreamQueryKeyFactory({
          ...values,
          liveStreamId: createdLiveStream._id,
        })!,
        createdLiveStream,
      );
      await queryClient.invalidateQueries({
        queryKey: liveStreamsQueryKeyFactory(),
      });
    },
  });
};
